import { createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import { combineReducers, applyMiddleware } from "redux";
import loggerMiddleware from "../Middleware/index";
// import rootReducer from "../rootReducer";

import Prompt from "../SnackBar/reducer";
import Loader from "../Loader/reducer";
import AuthReducer from "../Authentication/reducer";
import ProfileSettingsReducer from "../ProfileSettings/reducer";
import SiteSettingsReducer from "../SiteSettings/reducer";
import sidebarReducer from "../Sidebar/reducer";
import timezoneReducer from "../TimeZone/reducer"
// import TabReducer from "Pages/Modals/Driver/Create/Redux/Reducer";

import logger from "redux-logger";

const combinedReducers = combineReducers({
  snackbar: Prompt,
  Loader: Loader,
  AuthReducer: AuthReducer,
  ProfileSettingsReducer: ProfileSettingsReducer,
  SiteSettingsReducer: SiteSettingsReducer,
  sidebar: sidebarReducer,
  timezone: timezoneReducer,
});

//
// Apply middleware
const middleware = applyMiddleware(loggerMiddleware);

// Create the store with devtools and middleware
const store = createStore(combinedReducers, composeWithDevTools(middleware));

export default store;
